import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import React from 'react';
import { l } from 'app/blocks/common/codes';
import closeFilledIcon from './icons/close-filled.svg';
import searchFilledIcon from './icons/search-filled.svg';

export interface StaticSearchInputProps {
    clearSearch: () => void;
    handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    hasClearableText: boolean;
    inputValue: string;
    onFocus?: () => void;
}

function StaticSearchInput({
    InputLabelProps,
    InputProps,
    clearSearch,
    handleKeyDown,
    hasClearableText,
    inputProps,
    onFocus,
    ...textFieldParams
}: StaticSearchInputProps & AutocompleteRenderInputParams) {
    return (
        <TextField
            {...textFieldParams}
            className="StaticSearch-root"
            slotProps={{
                htmlInput: {
                    ...inputProps,
                    'aria-label': l('SEARCH_CODES.STATIC.HEADER'),
                    maxLength: 200,
                    onFocus,
                    onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                        handleKeyDown(event);
                        inputProps?.onKeyDown?.(event as any);
                    },
                },
                input: {
                    ...InputProps,
                    endAdornment: (
                        <>
                            {hasClearableText && (
                                <InputAdornment className="StaticSearch-clearAdornment" position="end">
                                    <button
                                        aria-label={l('SEARCH_CODES.STATIC.CLEAR_SEARCH')}
                                        className="StaticSearch-clearButton"
                                        onClick={event => {
                                            event.stopPropagation();
                                            clearSearch();
                                        }}
                                        onMouseDown={event => {
                                            event.preventDefault();
                                        }}
                                        type="button"
                                    >
                                        <span aria-hidden className="StaticSearch-clearButton-srLabel">
                                            {l('SEARCH_CODES.STATIC.CLEAR_SEARCH')}
                                        </span>
                                        <img
                                            alt=""
                                            aria-hidden
                                            className="StaticSearch-clearButton-icon"
                                            decoding="async"
                                            src={closeFilledIcon}
                                        />
                                    </button>
                                </InputAdornment>
                            )}
                            {InputProps?.endAdornment}
                            <InputAdornment className="StaticSearch-searchAdornment" position="end">
                                <span aria-hidden className="StaticSearch-searchIconWrap">
                                    <img
                                        alt=""
                                        aria-hidden
                                        className="StaticSearch-searchIcon"
                                        decoding="async"
                                        src={searchFilledIcon}
                                    />
                                </span>
                            </InputAdornment>
                        </>
                    ),
                },
                inputLabel: {
                    ...InputLabelProps,
                },
            }}
        />
    );
}

export default StaticSearchInput;
